type GetElementsReturnType = [string, string, string][];

export function getElements(parts: string[]): GetElementsReturnType {
    if (!parts?.length) return [];

    const [paired, children, unpaired, after] = parts.slice(0, 4);
    return [[paired || unpaired, children || '', after]].concat(
        getElements(parts.slice(4))
    ) as GetElementsReturnType;
}
